import swal from 'sweetalert2';

export const Message = swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.addEventListener('mouseenter', swal.stopTimer);
    toast.addEventListener('mouseleave', swal.resumeTimer);
  },
});

export const MessageWithIcon = (message, status) => {
  return Message.fire({
    text: message,
    icon: status,
  });
};
